import { FilterType } from "@/Pages/Cases/filtering/FilterType";
import { filterNulls } from "@/Pages/Cases/functions/filterNulls";
import type { DashboardFiltersInUser } from "@/Pages/Cases/filtering/DashboardFiltersInUser";

export const convertFilterToRequestBody = (element: DashboardFiltersInUser | null): string | null => {
  return element
    ? JSON.stringify({
        id: element.id,
        name: element.name,
        hospitals: JSON.stringify(element[FilterType.hospitals]),
        complaints: JSON.stringify(element[FilterType.complaints]),
        emsAgencies: JSON.stringify(element[FilterType.ems]),
      })
    : null;
};

export const convertFiltersToRequestBody = (filters: DashboardFiltersInUser[]): string[] => {
  return filterNulls(filters.map((element) => convertFilterToRequestBody(element)));
};
